<template>
	<section
		class="layout-center805"
	>

		<MapDevice
			:source-data="mapSource"
			:selected-areas-data="instance.areas"
			:search-query="searchQuery"
			class="layout_block-full_width"
			:campaign-id="context.instance.id"
			:without-control="true"

			@update="updateMapAndStats"
		/>


		<div class="request_create-step03 cl-container" >
			<section
				class="request_create-step03--form cl-xs8"
			>

				<div class="data_block">
					<h3>
						{{ $t('campaign.city_label') | capitalize }}
					</h3>

					<NiceSelect
						v-model="instance.cities"
						:options="getCityOptions"
						multiple
						show-check
						required
						class="cities"
						:invalid="!instance.cities || instance.cities.length === 0"
						:error="context.errors.cities"
					/>

					<ul class="selected-cities">
						<li
							v-for="(city, i) in instance.cities"
							:key="i"
						>—&nbsp;{{ city }}</li>
					</ul>
				</div>

				<!-- Audience -->
				<div class="data_block">
					<h3>
						{{ $t('campaign.audience_label') | capitalize }}
						<nice-hint :hint="$t('campaign.audience_hint')" />
					</h3>

					<AudienceCpv
						:age.sync="instance.age"
						:gender.sync="instance.gender"
						:errors="{
							// age: context.errors.age,
							// gender: context.errors.gender,
						}"
					/>
				</div>

				<!-- Schedule -->
				<div class="data_block">
					<h3>{{ $t('campaign.budget_n_schedule_title') | capitalize }}</h3>

					<Schedule
						:time-period.sync="instance.time_period"
						:time-range.sync="instance.time_range"
						:schedule.sync="instance.schedule"
						:show-advanced-settings="true"

						:errors="{
							// time_period: {
							// 	start: context.errors.start_date,
							// 	end: context.errors.end_date,
							// },
							// schedule: context.errors.schedule,
						}"
					/>

					<!-- Message duration & rate -->
					<section
						class="duration-n-rate"
					>
						<nice-input
							v-model.number="instance.ad_duration"
							:label="$t('campaign.message_duration') | capitalize"
							type="number"
							min="1"
							max="300"
							step="1"
							:units="$t('campaign.sec')"
							:invalid="context.errors.ad_duration"
							required
							class="input--duration"
						/>

						<!-- :units="$t('campaign.per_hour')" -->
						<div>
							<nice-label
								:label="$t('campaign.frequency_limit') | capitalize"
								:hint="$t('campaign.per_device') | capitalize"

								class="ad-rate__label"
							/>
							<div class="ad-rate__input">
								<nice-input
									v-model.number="instance.ad_rate_per_hour"
									type="number"
									min="1"
									max="720"
									step="1"
									:invalid="context.errors.ad_rate_per_hour"
									required
									class="frequency-limit"
								/>
								<nice-select
									v-model="instance.ad_rate_multiplier"
									:options="adRateOptions"

									class="ad-rate__modifier"
								/>
							</div>
						</div>
						<!-- :label="$t('campaign.frequency_limit') | capitalize" -->
					</section>
					<!-- END: Message duration & rate -->
				</div>
				<!-- END: Schedule -->


				<!-- Budget -->

				<div class="data_block data_block--budget_and_max_bid">
					<div>
						<nice-switch
							v-if="showDailyBudget"
							id="daily-settings-switch"
							v-model="budgetIsDaily"
							label=""
							:caption-on="$t('campaign.daily_budget') | capitalize"
							:caption-off="$t('campaign.lifetime_budget') | capitalize"
						/>
						<nice-label
							v-else
							:label="$t('campaign.lifetime_budget') | capitalize"
						/>

						<template v-if="budgetIsDaily">
							<nice-input
								ref="daily_budget"
								v-model.number="instance.daily_budget"
								type="number"
								:units="$options.filters.formatCurrency(instance.currency)"
								min="0.0000"
								step="0.0001"
								:invalid="context.errors.daily_budget"
								required
								class="input--budget"
							/>
							<div class="input--description">
								{{ $t('campaign.budget_is_daily_hint') }}
							</div>
						</template>

						<template v-else>
							<nice-input
								ref="budget"
								v-model.number="instance.budget"
								type="number"
								:units="$options.filters.formatCurrency(instance.currency)"
								min="0.0000"
								step="0.0001"
								:invalid="context.errors.budget"
								required
								class="input--budget"
								@change="budgetChangeHandler"
							/>

							<div
								v-if="instance.owner_instance && instance.budget > instance.owner_instance.balance"
								class="control-row__message_errors"
							>
								{{ $t('campaign.budget_more_than_balance') }}
							</div>

							<div class="input--description">
								<div
									v-if="instance.budget"
									v-html="$t('campaign.budget_desc_spend_to', {
										budget_to_spend: $options.filters.formatCash(instance.budget, instance.currency)
									})"
								/>
								<div
									v-if="currentSelection"
									v-html="$t('campaign.budget_desc_max_budget', {
										budget_max_limit: $options.filters.formatCash(currentSelection.total_max_budget, instance.currency)
									})"
								/>
							</div>
						</template>
					</div>


					<div
						class="fixed-cost__container"
					>
						<nice-label
							:label="$t('campaign.fixed_cost') | capitalize"
							class="fixed-cost__label"
						/>
						<span class="fixed-cost__value">
							<span v-if="instance.max_bid">{{ instance.max_bid | formatNumber }}</span>
							<span v-else>—</span>
							<span class="fixed-cost__units">{{ instance.currency | formatCurrency }}</span>
						</span>
					</div>
					<p v-if="currentSelection" class="input--help_text" >
						{{ currentPaymentModel.label }}
						{{ $t('campaign.model_phrase', { seconds: $tc('campaign.seconds', instance.ad_duration) }) }}
					</p>

					<div
							class="fixed-cost__container"
					>
						<nice-label
								:label="$t('campaign.impressions_forecast') | capitalize"
								class="fixed-cost__label"
						/>
						<span class="fixed-cost__value">
							<span>{{ impressionsForecast }}</span>
<!--							<span class="fixed-cost__units">{{ instance.currency | formatCurrency }}</span>-->
						</span>
					</div>

				</div>

				<!-- Next button -->
				<nice-button-2
					filled
					icon-painted
					icon="arrow-14"
					icon-state="-90"
					icon-placement="end"
					class="next_button"
					:disabled="isAnyRequredFieldEmpty || isAnyErrorsFromBackend"
					@click="goToNext"
				>
					{{ $t('campaign.next_btn_label') }}
				</nice-button-2>

				<div class="control-row" >
					<span
						v-if="isAnyRequredFieldEmpty"
						class="control-row__message control-row__message"
					>{{ $t('errors.fill_required_fields') }}</span>

					<span
						v-if="isAnyErrorsFromBackend"
						class="control-row__message control-row__message_errors"
					>{{ $t('errors.resolve_errors') }}</span>
				</div>

			</section>
		</div>

	</section>
</template>


<script>
import _ from 'underscore';
import { mapState, mapActions, mapGetters } from 'vuex';

import moment from 'moment';

import apiDsp from '@/api/dsp/device';
import apiSsp from '@/api/ssp/device';
import { getDevicesFilter, objectToQuery } from '@/utilites';
import { request, getBaseApiUrl } from '@/api/request';

import MapDevice from '@/components/map-device';
import NiceHint from '@/ui/nice-hint';
import NiceInput from '@/ui/nice-input';
import NiceSelect from '@/ui/nice-select';
import NiceSwitch from '@/ui/nice-switch';

// partials. use global paths for ui overrides
import AudienceCpv from '@/pages/request/create/audience-cpv';
import Schedule from '@/pages/request/create/schedule';


// milliseconds
// TODO: how can we drop it or use short instead?
const DEBOUNCE_TIMEOUT = 1000;
// after areas update
const SHORT_DEBOUNCE_TIMEOUT = 500;

const MODEL = Object.freeze({
	prop: 'value',
	event: 'update:value',
});


export default {
	name: 'FlasterStep03',


	model: MODEL,


	components: {
		MapDevice,
		NiceHint,
		NiceInput,
		NiceSelect,
		NiceSwitch,

		AudienceCpv,
		// eslint-disable-next-line vue/no-unused-components
		Schedule,
	},


	props: {
		stepCurrent: {
			type: Number
		},

		stepCount: {
			type: Number
		},

		goToNext: {
			type: Function
		},

		goToPrev: {
			type: Function
		},

		[MODEL.prop]: {
			type: Object,
			default: ()=>({}),
		},

		/*
		 * contains `instance`, `step`
		 */
		context: {
			type: Object,
			required: true,
		},
	},


	data() {
		return {
			// inner value
			instance: {
				...this[MODEL.prop],
			},

			currentSelection: {
				// depends on payment_model
				'plays': {
					'value': 0,
					'total': 0,
				},
				'impressions': {
					'value': 0,
					'total': 0,
				},
				'plays_per_day': 0,
				'inventory': {
					'value': 0,
					'total': 0,
					'excel_url': '',
				},
				'price': {
					'min': 0,
					'max': 0,
					'avg': 0,
				},
				// [{type: 'monitor', resolution: '1920x1080', count: 21,}, ...]
				'specs': [],
				'devices_uptime': {
					'good_uptime': 0,
					'average_uptime': 0,
					'bad_uptime': 0,
				},
				'total_max_budget': 0,
			},

			mapSource: {
				'type': 'FeatureCollection',
				'features': [],
			},

			// search address
			searchQuery: '',

			requiredFields: [
				'cities',
				// 'start_date',
				// 'end_date',
				'time_period',
				'time_range',
				'ad_duration',
				'ad_rate_per_hour',
				'payment_model',
				'budget',
				'max_bid',
			],

			// delay so we don't spam MapBox & our stats endpoints
			debouncedUpdateMapAndStats: _.debounce(this.updateMapAndStats, DEBOUNCE_TIMEOUT),
			// we need a shorter delay after a map area manipulation
			// + there is a delay in `devicesFilter` update (because of `this.context.instance` update?)
			shortDebouncedUpdateMapAndStats: _.debounce(this.updateMapAndStats, SHORT_DEBOUNCE_TIMEOUT),

			budgetIsDaily: false,
		};
	},


	async created() {
		await Promise.all([
			this.$store.dispatch('extra/getPaymentModels'),
		]);
	},


	async mounted() {
		this.showLoader();

		await this.shortDebouncedUpdateMapAndStats();
	},


	computed: {
		...mapState('app', {
			appSide: 'side',
		}),

		...mapState('agency', {
			showDailyBudget: 'show_daily_budget',
		}),

		...mapGetters('extra', [
			'getPaymentModelByValue',
		]),


		currentPaymentModel() {
			return this.getPaymentModelByValue(this.instance.payment_model);
		},


		devicesFilter() {
			// we need only deployed devices here
			let filter = getDevicesFilter(this.context.instance, true);
			return objectToQuery(filter);
		},


		adRateOptions() {
			return Object.freeze([
				{
					label: this.$t('campaign.for_hour', {value: 1}),
					value: 1,
				},
				{
					label: this.$t('campaign.for_minutes', {value: 30}),
					value: 2,
				},
				{
					label: this.$t('campaign.for_minutes', {value: 10}),
					value: 6,
				},
				{
					label: this.$t('campaign.for_minutes', {value: 5}),
					value: 12,
				},
				{
					label: this.$t('campaign.for_minutes', {value: 2}),
					value: 30,
				},
			]);
		},


		isAnyRequredFieldEmpty() {
			return this.requiredFields.some(field => {
				let result = !this.instance[field];

				if (field === 'cities' && this.instance[field]) {
					result = this.instance[field].length === 0;
				}

				if (field === 'time_period') {
					let tp = this.instance.time_period;
					result = !(tp !== null && typeof tp === 'object' && tp.start && tp.end);
				}

				return result;
			});

		},


		isAnyErrorsFromBackend() {
			return [
				'areas',
				// 'platforms',
				'age',
				'gender',
				'interests',
				'life_stages',
				'intents',
				'environments',
				'pois',
				'cities',
				'resolutions',
				'orientations',
				'device_types',
				//'time_period', // see below
				'start_date',
				'end_date',
				'time_range',
				'schedule',
				'ad_duration',
				'ad_rate_per_hour',
				'payment_model',
				'budget',
				'max_bid',
			].some(field => this.context.errors[field]);
		},

		impressionsForecast() {
			if (!this.instance.max_bid) {
				return '—';
			}

			const max_bid = parseFloat(this.instance.max_bid.toFixed(2));
			const value = this.budgetIsDaily ? this.instance.daily_budget : this.instance.budget;
			const forecast = Math.round(value/max_bid);

			if (Number.isNaN(forecast)) {
				return '—';
			}

			return forecast;
		},

	},  // END: computed


	methods: {
		...mapActions('devices', [
			'getStats',
		]),


		showLoader() {
			// HACK: we have a very bad defaults calculation mechanic
			let loader = this.$loading.show();
			setTimeout(() => {
				loader.hide();
			}, 3000);

			return loader;
		},


		/**
		 * We update `budget` automatically unless use set it manually
		 */
		budgetChangeHandler(event) {
			this.instance = {
				...this.instance,
				'is_budget_manually_set': true,
			};
		},


		async getCityOptions(event) {
			const response = await this.getApi().networkCities(event.query);

			return response.results.map(city => ({
				value: city.city_name,
				label: city.city_name || ' ',  // clicks don't work w/o data
			}));
		},


		async updateMapAndStats() {
			const loader = this.showLoader();

			// can we make it in parallel? looks OK
			await Promise.all([
				this.setMapSource(),
				this.updateStats(),
			]);

			this.updateBudget(this.currentSelection);
			this.updateMaxBid(this.currentSelection);

			// we need to triger `isAnyRequredFieldEmpty` recalc - it doesn't see into `this.instance`
			this.instance = {
				...this.instance,
			};

			loader.hide();
		},


		/**
		 * We still need it
		 */
		async updateStats() {
			let loading = this.$loading.show();

			const res = await this.getStats({
				filter: this.devicesFilter,
			});
			await this.$set(this, 'currentSelection', res);

			loading.hide();
		},


		/**
		 * Automatically update `budget` if it isn't set manually
		 */
		updateBudget(stats) {
			if (this.instance.is_budget_manually_set) {
				return;
			}

			// Round up to 0.01, example of valid price is 0.18 dollars
			var rounded_budget = Math.round(stats.total_max_budget * 100) / 100;
			if (this.instance.budget !== rounded_budget) {
				this.instance.budget = rounded_budget;
			}
		},


		/**
		 * Fixed placement - only max bid here!!!
		 */
		updateMaxBid(stats) {
			let max_bid = 0;

			// max_bid = parseFloat(stats.price.max.toFixed(2));
			max_bid = parseFloat(stats.price.max);
			// this.instance.max_bid = max_bid;

			if (this.instance.max_bid !== max_bid) {
				this.instance.max_bid = max_bid;
			}
		},


		getApi() {
			return this.appSide == 'ssp' ? apiSsp : apiDsp;
		},


		async setMapSource() {
			const apiPath = this.getApi().getPrefix().slice(0,-1);

			let filter = this.devicesFilter;
			// HACK: to show all devices if platform is not selected
			if (this.devicesFilter.indexOf('platforms=') == -1) {
				filter += '&platforms=all';
			}

			const url = `${getBaseApiUrl()}${apiPath}.geojson${filter}`;

			const result = await request(url);

			this.$set(this, 'mapSource', result);
		},

		getDaysCount() {
			const start = this.instance.start_date;
			const end = this.instance.end_date;

			const diff = moment(end).diff(moment(start), 'days');
			return isNaN(diff) ? 0 : diff + 1;
		},

	},


	watch: {

		[MODEL.prop]: {
			deep: true,
			async handler(newValue, oldValue) {
				if (_.isEqual(newValue, this.instance)) {
					return;
				}

				this.instance = JSON.parse(JSON.stringify(newValue));
			}
		},

		instance: {
			deep: true,
			async handler(newValue, oldValue) {
				if (_.isEqual(newValue, this[MODEL.prop])) {
					return;
				}

				// TODO: BUG: `id` might disappear from the instance here
				if (oldValue && oldValue.id && newValue && !newValue.id) {
					this.$log.warn(`No request ID in the new value! Old value ID ${oldValue.id}`);
					return;
				}

				this.$emit(MODEL.event, JSON.parse(JSON.stringify(newValue)));
			},
		},

		/**
		 * Update request/campaign stats on filter change
		 *
		 * TODO: devicesFilter is a string but could be an object. change?
		 *
		 * NB: depends on `this.context.instance`
		 *
		 * debounced
		 */
		devicesFilter: {
			deep: true,
			async handler(newValue, oldValue) {
				if (_.isEqual(newValue, oldValue)) {
					return;
				}

				await this.debouncedUpdateMapAndStats();
			},
		},

		budgetIsDaily(newVal) {
			if (newVal) {
				const days = this.getDaysCount();
				this.instance.budget = this.instance.daily_budget * days;
			} else {
				this.instance.daily_budget = 0;
			}
		},

		'instance.daily_budget'(val) {
			if (this.budgetIsDaily) {
				const days = this.getDaysCount();
				this.instance.budget = val * days;
			}
		},

	},  // END: watch

};
</script>


<style lang="sass" scoped >
$column_indent: 45px
$row--indent: 20px
$row--width: 330px

h3
	display: flex
	flex-direction: row
	flex-wrap: nowrap
	justify-content: flex-start
	align-items: center
	align-content: center

	.nice-hint
		margin-left: 7px

.map
	height: 372px
	margin-bottom: $cmpnt-rc__content-margin-default

.request_create-step03--card
	position: sticky
	top: 20px

.cities
	width: fit-content

.selected-cities
	margin: 0
	padding: 0
	list-style: none

.data_block
	display: flex
	flex-direction: column
	flex-wrap: nowrap
	justify-content: flex-start
	align-items: stretch

	margin-top: $cmpnt-rc__content-margin-default
	margin-bottom: $cmpnt-rc__content-margin-default * 1.3

	> *
		margin-bottom: $row--indent

		&:first-child
			margin-top: 0

		&:last-child
			margin-bottom: 0

	h3
		font-weight: normal
		font-size: $fsz__new__section-title

// .time_period
// 	max-width: $row--width

// .select_areas
// 	margin-right: $column_indent

.duration-n-rate
	display: flex
	flex-direction: row

	.frequency-limit
		margin-left: 40px
		width: 42px

		&::before
			content: '<'
			color: $nice_color-darkgray
			position: absolute
			bottom: 7px
			left: -10px

			.input--duration
				width: 132px

	.ad-rate__input
		display: flex
		flex-direction: row

	.ad-rate__label
		margin-left: 40px

	.ad-rate__modifier
		margin-left: 10px

.input--budget,
.input--max_bid
	max-width: 225px

	::v-deep
		.ni_input--input,
		.ni_input--units
			// margin-top: 30px
			font-size: $fsz__title
			font-weight: 300

.input--help_text
	margin-top: 0

	font-size: $fsz__section-title
	color: var(--text_2_color)

.input--description
	margin-top: 0
	margin-bottom: 30px

.next_button
	width: 100%
	height: 40px
	margin-bottom: 10px

.control-row
	display: flex
	flex-direction: row
	flex-wrap: nowrap
	justify-content: flex-start
	// margin-right: $column_indent
	align-items: center

	& > *
		margin-right: 15px

.control-row__message
	display: inline-block
	// color: var(--text_2_color)
	color: $nice_color-red

.control-row__message_errors
	color: $nice_color-red

.fixed-cost__container
	display: flex
	flex-direction: column

.fixed-cost__value
	width: 81px
	height: 23px

	font-weight: 300
	font-size: 20px
	line-height: 23px

.fixed-cost__units
	color: #919191
	margin-left: 5px

//
// Deep
//

::v-deep
	.mapboxgl-ctrl-geocoder.mapboxgl-ctrl
		visibility: hidden
		display: none

	.ni_input--autocomplete
		width: 200%

	.ni_input--units
		color: var(--text_2_color)
</style>
